// extracted by mini-css-extract-plugin
export default {"-large":"Rw0GVu49S5FxN2_kMLp8","mainLoaderHeight":"INlOn0zl1kgUbYwaL0lb"};